import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Stack,
    Box,
    TextField,
    Typography,
    Breadcrumbs,
    Link,
    Button,
    IconButton,
    Tooltip,
} from '@mui/material';
import QueryTemplates from './QueryTemplates';
import { usePostSearch } from '../api/ContentApi';
import RoutePaths from '../routes/RoutePaths';
import { FormattedMessage, useIntl } from 'react-intl';
import QueryFilters from './QueryFilters';
import InfoIcon, { InfoTooltip } from './InfoIcon';
import { InfoOutlined, Replay } from '@mui/icons-material';

const DEBUG = true;
const REACT_APP_FEATURE_SEARCH_TEMPLATES = process.env.REACT_APP_FEATURE_SEARCH_TEMPLATES === "true"

export const QueryLibrary = () => {
    return (
        <Box>
            <Breadcrumbs aria-label="breadcrumb">
                Hello
            </Breadcrumbs>
            <Breadcrumbs aria-label="breadcrumb">
                Hello
            </Breadcrumbs>
            <Breadcrumbs aria-label="breadcrumb">
                Hello
            </Breadcrumbs>
            <Breadcrumbs aria-label="breadcrumb">
                Hello
            </Breadcrumbs>
        </Box>
    )
}

/*export const QueryFilters = () => {
    return (
        <Box>
            <Breadcrumbs aria-label="breadcrumb">
                <Link color="inherit" href="#">
                    Lisää..
                </Link>
            </Breadcrumbs>
        </Box>
    )
}*/

export const QueryInput = ({ value, setValue, onSend, disabled }) => {
    return (<TextField
        label="Kyselyohje"
        multiline
        rows={4}
        variant="outlined"
        value={value}
        onChange={(event) => setValue(event.target.value)}
        onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey && !disabled) {
                e.preventDefault(); // Prevents newline in the text field
                onSend();
            }
        }}
        fullWidth
        disabled={disabled}
    />)
};

const Query = ({
    configuration,
    input,
    setInput,
    selectedSearch,
    searchMutation
}) => {
    const intl = useIntl();
    const [filters, setFilters] = useState([]);
    const navigate = useNavigate();

    const buttonTextGenerate = intl.formatMessage({ id: "query.generate" });
    const buttonTextGenerating = intl.formatMessage({ id: "query.generating" });

    useEffect(() => {
        if (selectedSearch) {
            if (selectedSearch.filters) {
                setFilters(selectedSearch.filters);
            } else {
                setFilters([]);
            }
        } else {
            setInput("");
            setFilters([]);
        }
    }, [selectedSearch]);

    return (
        <Stack direction="column" spacing={2}>
            <Stack direction="row" spacing={2} justifyContent="space-between" alignItems="center">
                <Typography variant="h6">Aineistokysely <InfoIcon id="info.query.input" /></Typography>
                <Tooltip title={<FormattedMessage id="info.query.clear" />}>
                    <IconButton
                        disabled={searchMutation.isPending}
                        onClick={() => {
                            setInput("");
                            setFilters([]);
                            navigate(`${RoutePaths.root.root}`);
                        }}>
                        <Replay></Replay>
                    </IconButton>
                </Tooltip>
            </Stack>
            {
                REACT_APP_FEATURE_SEARCH_TEMPLATES &&
                <QueryTemplates
                    queryTemplates={configuration.queryTemplates}
                />
            }
            <QueryInput
                value={input}
                setValue={setInput}
                onSend={() => {
                    searchMutation.mutate({
                        query: input,
                        filters
                    })
                }}
                disabled={searchMutation.isPending}
            />
            <br />
            <Typography variant="h6">Aineistorajaus <InfoIcon id="info.query.filters" /></Typography>
            <QueryFilters
                filterOptions={configuration.filterOptions}
                filters={filters}
                setFilters={setFilters}
            />
            <br />
            <InfoTooltip title={<FormattedMessage id="info.query.search" />}>
                <Button
                    disabled={searchMutation.isPending}
                    onClick={() => {
                        searchMutation.mutate({
                            query: input,
                            filters
                        })
                    }}
                    variant="contained">
                    {
                        searchMutation.isPending ?
                            buttonTextGenerating
                            : buttonTextGenerate
                    }
                </Button>
            </InfoTooltip>
            {
                searchMutation.isError &&
                <Stack
                    direction="row"
                    spacing={0.5}
                    mt={0.6}
                    sx={{
                        display: 'flex',
                        alignItems: 'start',
                    }}>
                    <InfoOutlined /> <Typography variant="caption">
                        <FormattedMessage id="error.results" />
                    </Typography>
                </Stack>
            }
        </Stack>
    );
}

export default Query;